module.exports = __webpack_public_path__ + "static/media/out-of-gun-stock.e07454da.png";